import React, { useEffect, useRef, useState } from "react";
import styles from "./CatalogHero.module.scss";
import Container from "../Container/Container";
import { products } from "../../data/catalog";
import ProductPreview from "../ProductPreview/ProductPreview";
import TitleUnderline from "../TitleUnderline/TitleUnderline";
import Accordion from "../Accordion/Accordion";
import { wordEnding } from "../../helpers/wordEnding";
import Tag from "../Tag/Tag";
import Radio from "../Radio/Radio";
import Pagination from "../Pagination/Pagination";
import DefaultButton from "../DefaultButton/DefaultButton";
import { useWindowWidth } from "../../hooks/useWindowWidth";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Hr from "../Hr/Hr";
import CloseIcon from "public/icons/close.svg";
import { useRouter } from "next/router";
import cn from "classnames";
import CatalogTag from "../CatalogTag/CatalogTag";
import ArrowIcon from "public/icons/arrow.svg";
import CatalogSidebar from "../CatalogSidebar/CatalogSidebar";
import { ICategory } from "../../interfaces/categoryProducts.interface";
import { ICategories } from "../../interfaces/categories.interface";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { productsActions } from "../../store/productSlice";
import { CheckboxGreen } from "../CheckboxGreen/CheckboxGreen";
import { searchActions } from "../../store/searchSlice";
import Modal from "../Modal";

interface CatalogHeroProps {
    products?: ICategory;
    categories: ICategories;
    countProducts?: ICategory;
    isLoading: boolean;
}

const CatalogHero = ({
                         countProducts,
                         isLoading,
                         categories,
                         products,
                     }: CatalogHeroProps) => {
    const [active, setActive] = useState(null);
    const [page, setPage] = useState<number>(1);
    const width = useWindowWidth();
    const [openFilters, setOpenFilters] = useState<boolean>(false);
    const router = useRouter();
    const [openShow, setOpenShow] = useState(false);
    const [pageSize, setPageSize] = useState(12);
    const dispatch = useAppDispatch();
    const categoryActive = useAppSelector(
      (state) => state.productsReducer.categories
    );
    const tags = useAppSelector((state) => state.productsReducer.tags);
    const openFiltersMain = useAppSelector(
      (state) => state.productsReducer.openTags
    );
    const modalRef = useRef(null);

    useEffect(() => {
        const modalElement = document.getElementById("modal");
        if (openFilters) {
            disableBodyScroll(modalElement, { reserveScrollBarGap: true });
        } else if (!openFilters) {
            enableBodyScroll(modalElement);
        }
    }, [openFilters]);

    useEffect(() => {
        dispatch(productsActions.setPageSize(pageSize));
    }, [pageSize]);

    useEffect(() => {
        setActive(categories.data.findIndex((e) => e.slug == router.query.slug));
    }, [router.query]);

    const [parentCategory, setParentCategory] = useState(
      categories.data.find((e) => e.slug == router.query.slug).id
    );

    useEffect(() => {
        dispatch(productsActions.setPage(page));
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [page]);

    useEffect(() => {
        dispatch(productsActions.setPageSize(pageSize));
        setPage(1);
    }, [pageSize]);

    useEffect(() => {
        setPage(1);
    }, [tags, categoryActive]);

    return (
      <Container className={styles.container}>
          <TitleUnderline>Каталог нашей продукции</TitleUnderline>
          <div className={styles.root}>
              <CatalogSidebar categories={categories} />
              <main className={styles.main}>
                  {isLoading ? (
                    <div className={styles.loader}></div>
                  ) : (<>
                      {
                          <div className={styles.filters}>
                              {!(width <= 1279) ? (
                                products.tags.length && openFiltersMain ? (
                                  <div className={styles.tags}>
                                      {products.tags?.map((e) => (
                                        <CatalogTag
                                          active={tags.includes(e.id)}
                                          onClick={() => {
                                              if (tags.includes(e.id)) {
                                                  dispatch(productsActions.removeTag(e.id));
                                              } else {
                                                  dispatch(productsActions.setTags(e.id));
                                              }
                                          }}
                                          tag={e}
                                        />
                                      ))}
                                      {tags.length ? (
                                        <button
                                          onClick={() => dispatch(productsActions.throwTags())}
                                          className={styles.all}
                                        >
                                            Сбросить все
                                        </button>
                                      ) : null}
                                  </div>
                                ) : null
                              ) : (
                                <DefaultButton
                                  onClick={() => setOpenFilters(true)}
                                  className={styles.buttonFilters}
                                >
                                    <div className={styles.buttonInner}>
                                        <svg
                                          width="19"
                                          height="17"
                                          viewBox="0 0 19 17"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                              d="M9.34766 3.69678L17.3477 3.69678"
                                              stroke="white"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                            />
                                            <path
                                              d="M1.34766 3.69678L5.34766 3.69678"
                                              stroke="white"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                            />
                                            <path
                                              d="M14.3477 13.6968L17.3477 13.6968"
                                              stroke="white"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                            />
                                            <path
                                              d="M1.34766 13.6968L9.34766 13.6968"
                                              stroke="white"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                            />
                                            <circle
                                              cx="7.34766"
                                              cy="3.69678"
                                              r="2"
                                              transform="rotate(90 7.34766 3.69678)"
                                              stroke="white"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                            />
                                            <circle
                                              cx="12.3477"
                                              cy="13.6968"
                                              r="2"
                                              transform="rotate(90 12.3477 13.6968)"
                                              stroke="white"
                                              stroke-width="1.5"
                                              stroke-linecap="round"
                                            />
                                        </svg>
                                        <span>Фильтры</span>
                                    </div>
                                </DefaultButton>
                              )}
                          </div>
                      }
                      <div className={styles.active}>
                          {countProducts && <div className={styles.length}>
                              {countProducts.data.length}{" "}
                              {wordEnding(countProducts.data.length, [
                                  "товар",
                                  "товара",
                                  "товаров",
                              ])}
                          </div>}
                          <button
                            onMouseLeave={() => setOpenShow(false)}
                            className={cn(styles.show, {
                                [styles.activeShow]: openShow,
                            })}
                            onClick={() => setOpenShow(true)}
                          >
                              <div>Показывать по: {pageSize}</div>
                              <ArrowIcon />
                              {openShow && (
                                <div className={styles.pageSize}>
                                    <div onClick={() => setPageSize(12)}>12</div>
                                    <div onClick={() => setPageSize(24)}>24</div>
                                </div>
                              )}
                          </button>
                      </div>
                      <div className={styles.catalog}>
                          {products.data.map((e) => (
                            <ProductPreview product={e} />
                          ))}
                      </div>
                      <Pagination
                        className={styles.pagination}
                        onPageChange={setPage}
                        totalCount={countProducts && countProducts.data.length}
                        siblingCount={1}
                        currentPage={page}
                        pageSize={pageSize}
                      />
                      {width < 1279 && openFilters && (
                        <Modal
                          isOpen={openFilters}
                          onRequestClose={() => setOpenFilters(false)}
                          className={cn(styles.filtersModal)}
                        >
                            <div className={styles.header}>
                                <h3 className={styles.filtersTitle}>Фильтры</h3>
                                <div className={styles.buttons}>
                                    {tags.length ? (
                                      <button
                                        onClick={() => dispatch(productsActions.throwTags())}
                                        className={styles.all}
                                      >
                                          Сбросить все
                                      </button>
                                    ) : null}
                                    <CloseIcon onClick={() => setOpenFilters(false)} />
                                </div>
                            </div>
                            <Hr />
                            {openFiltersMain && (
                              <div className={styles.filtersMobile}>
                                  {products.tags.map((e) => (
                                    <CatalogTag
                                      active={tags.includes(e.id)}
                                      onClick={() => {
                                          if (tags.includes(e.id)) {
                                              dispatch(productsActions.removeTag(e.id));
                                          } else {
                                              dispatch(productsActions.setTags(e.id));
                                          }
                                      }}
                                      tag={e}
                                    />
                                  ))}
                              </div>
                            )}
                            <Hr />
                            <div className={styles.categories}>
                                {categories.data.map((category, i) => (
                                  <Accordion
                                    contentMargin={25}
                                    contentClassName={styles.content}
                                    className={styles.accordion}
                                    onClick={() => {
                                        dispatch(productsActions.hideTags());
                                        if (active == i) {
                                            setActive(null);
                                        } else {
                                            setActive(i);
                                            router.push(`/products/${category.slug}`);
                                            dispatch(productsActions.throwTags());
                                            setParentCategory(category.id);
                                            dispatch(
                                              productsActions.setRadioCategory(category.id)
                                            );
                                        }
                                    }}
                                    index={i}
                                    active={active}
                                    title={category.title}
                                  >
                                      <div className={styles.radios}>
                                          {i != 0 && (
                                            <Radio
                                              checked={categoryActive.includes(category.id)}
                                              onChange={() => {
                                                  dispatch(productsActions.throwTags());
                                                  dispatch(productsActions.hideTags());
                                                  dispatch(
                                                    productsActions.setRadioCategory(category.id)
                                                  );
                                              }}
                                              name={"catalogMobileRadio"}
                                            >
                                                Все товары
                                            </Radio>
                                          )}
                                          {category.children_categories.map((e) =>
                                            i != 0 ? (
                                              <Radio
                                                checked={categoryActive.includes(e.id)}
                                                onChange={() => {
                                                    dispatch(productsActions.throwTags());
                                                    dispatch(productsActions.showTags());
                                                    dispatch(
                                                      productsActions.setRadioCategory(e.id)
                                                    );
                                                }}
                                                name={"catalogMobileRadio"}
                                              >
                                                  {e.title}
                                              </Radio>
                                            ) : (
                                              <CheckboxGreen
                                                checked={categoryActive.includes(e.id)}
                                                onChange={() => {
                                                    dispatch(productsActions.hideTags());
                                                    dispatch(
                                                      productsActions.removeCategory(category.id)
                                                    );
                                                    dispatch(productsActions.throwTags());
                                                    dispatch(productsActions.showTags());
                                                    if (categoryActive.includes(e.id)) {
                                                        dispatch(
                                                          productsActions.removeCategory(e.id)
                                                        );
                                                    } else {
                                                        dispatch(productsActions.setCategory(e.id));
                                                    }
                                                }}
                                                label={e.title}
                                              />
                                            )
                                          )}
                                      </div>
                                  </Accordion>
                                ))}
                            </div>
                            <div
                              className={cn(styles.activeButtons, {
                                  [styles.openButtons]: true,
                              })}
                            >
                                <DefaultButton
                                  onClick={() => {
                                      setOpenFilters(false);
                                  }}
                                  className={styles.accept}
                                >
                                    Показать
                                </DefaultButton>
                                <DefaultButton
                                  onClick={() => {
                                      dispatch(productsActions.hideTags());
                                      dispatch(
                                        productsActions.setRadioCategory(parentCategory)
                                      );
                                      dispatch(productsActions.throwTags());
                                  }}
                                  fill={false}
                                  className={styles.throw}
                                >
                                    Сбросить
                                </DefaultButton>
                            </div>
                        </Modal>
                      )}
                  </>)}
              </main>
          </div>
      </Container>
    );
};

export default CatalogHero;
